import React, { FC } from 'react';
import { compose } from 'recompose';
import { connect, FormikProps } from 'formik';
import { Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { INetwork, IShare } from '../types';

interface IProps {
  network: INetwork;
}

interface IPropsEnhanced extends IProps, WithStyles<typeof styles> {
  formik: FormikProps<IShare>;
}

const styles = (theme: Theme) =>
  createStyles({
    safe: {
      color: theme.custom.palette.grey1,
    },
    warning: {
      color: theme.custom.palette.orange,
    },
    error: {
      color: theme.custom.palette.red,
    },
  });

const enhancers = compose<IPropsEnhanced, IProps>(connect, withStyles(styles));

const Count: FC<IPropsEnhanced> = ({ classes, formik, network }) => {
  const { values } = formik;
  const { provider } = network;

  const item = values[provider];
  const { active, limit, user_commentary } = item;
  const safeLimit = limit || 200;

  if (!active) {
    return null;
  }

  const difference = safeLimit - (user_commentary || '').length;
  const currentCount = (user_commentary && user_commentary.length) || 0;

  const className = classNames({
    [classes.safe]: difference >= 21,
    [classes.warning]: difference <= 20,
    [classes.error]: difference < 0,
  });

  return (
    <Typography className={className}>
      {currentCount}/{safeLimit}
    </Typography>
  );
};

export default enhancers(Count);
